import * as React from "react";
import { cn } from "@/lib/utils";
import RoleGuard from "@/core/auth/components/role-guard";

export interface PageHeaderProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
  /** Roles allowed to see `action`. Omit to show it to everyone. */
  actionRoles?: string[];
  className?: string;
}

export function PageHeader({
  title,
  description,
  action,
  actionRoles,
  className,
}: PageHeaderProps) {
  const renderedAction = actionRoles ? (
    <RoleGuard requiredRoles={actionRoles}>{action}</RoleGuard>
  ) : (
    action
  );

  return (
    <div
      className={cn(
        "flex items-center justify-between mb-8",
        className
      )}
    >
      <div className="space-y-1">
        <h1 className="text-3xl font-bold tracking-tight">{title}</h1>
        {description && (
          <p className="text-muted-foreground">{description}</p>
        )}
      </div>
      {action && renderedAction}
    </div>
  );
}
